import { Header, Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import DropdownMenu from "../../../ui/components/DropdownMenu/DropdownMenu";
import ErrorMessage from "../../../ui/components/Messages/ErrorMessage";
import useBreadcrumbs from "../../../ui/hooks/useBreadcrumbs";
import PageView from "../../../ui/views/PageView/PageView";

import useHasRole from "../../../authorization/hooks/useHasRole";

import ImportReports from "../../components/ImportReports/ImportReports";
import ImportStatusLabel from "../../components/ImportStatus/ImportStatusLabel";
import useImportDropdownMenuOptions from "../../hooks/useImportDropdownMenuOptions";

export default function ImportView({ article, importt }) {
	const { t } = useTranslation();
	const hasRole = useHasRole();

	const breadcrumbs = useBreadcrumbs({ article, importt });

	const dropdownMenuOptions = useImportDropdownMenuOptions();

	return (
		<PageView
			breadcrumbs={breadcrumbs}
			header={importt.title || importt.created.toDate().toLocaleString()}
			subheader={importt.source}
			extra={
				<>
					<ImportStatusLabel importt={importt} />
					<DropdownMenu options={dropdownMenuOptions(importt)} />
				</>
			}
		>
			{importt.error && <ErrorMessage error={importt.error} />}

			<Header as="h3">{t("sourceData", "Source data")}</Header>

			<Segment inverted style={{ marginBottom: 7, overflowX: "auto" }}>
				<pre>{JSON.stringify(importt.data, null, 2)}</pre>
			</Segment>

			{hasRole("owner", "admin") && <ImportReports importt={importt} />}
		</PageView>
	);
}
